export default [
  {
    name: 'Contratos de Trabajadores',
    icon: 'mdi-briefcase-account',
    path: '/admin/laboral/workers',
    component: () => import(/* webpackChunkName: "admin-workers" */ './views/WorkersAdminPage.vue'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
  {
    name: 'Solicitudes Laboral',
    icon: 'mdi-briefcase-upload',
    path: '/admin/laboral/requests',
    props: {
      adminView: true,
    },
    component: () =>
      import(/* webpackChunkName: "admin-laboral-requests" */ './views/LaboralRequestsAdminPage.vue'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      adminBadge: true,
      tooltip: null,

      adminBadgeContent: 'unreadedLaboralRequests',
      adminBadgeChecker: 'userLaboralRequestsReady',
    },
  },
];
